import { render, staticRenderFns } from "./Anagrafica1.vue?vue&type=template&id=30d5fb71&"
import script from "./Anagrafica1.vue?vue&type=script&lang=js&"
export * from "./Anagrafica1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports